import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, first, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { get } from 'lodash';

import { AppState } from '../../store/state/app.state';
import { selectTeamsUser } from '../store/selectors';
import { HrmService } from '../hrm.service';
import { UpdateShouldRefreshEntity, UpdateUserCurrentState } from '../store/actions/teams.actions';
import { AuthService } from 'common/src/auth/auth.service';
import { UIStatesEnum } from 'common/src/models';
import { UserProfileModel } from '../models';

@Injectable()
export class MyProfileGuard implements CanActivate {

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly hrmService: HrmService,
    private readonly store: Store<AppState>
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {

    return this.store.select(selectTeamsUser).pipe(
      first(),
      switchMap((user: UserProfileModel) => {
        const loggedUser = this.authService.getUser();
        const isEntityExistAndSameId = user && get(user, 'profile.id') === loggedUser.id;
        this.store.dispatch(UpdateShouldRefreshEntity({ isShouldRefresh: isEntityExistAndSameId }));
        return (isEntityExistAndSameId) ? of(user) : this.hrmService.getUserProfileAndBlueprintsV2(loggedUser.id);
      }),
      catchError(() => {
        this.router.navigate(['/team']);
        return of(false);
      }),
      switchMap(() => {
        this.store.dispatch(UpdateUserCurrentState({currentState: UIStatesEnum.VIEW}));
        return of(true);
      })
    );
  }
}
